<template>
  	<v-layout row wrap justify-end class="section-create">
		<v-flex xs12 md6></v-flex>
		<v-flex xs12 md6 class="content-text">
			<p class="title-create">LA HEMOS CREADO PARA TI</p>
			<p class="description">Una herramienta útil que facilitará tus ventas.</p>
			<p class="description">Una solución práctica que te permitirá administrar tu negocio desde tu computador o celular.</p>
			<a href="#footer">
				<button class="btn-information">Solicita más información</button>
			</a>
		</v-flex>
		<v-flex xs12 hidden-md-and-up class="banner-last-mobile"></v-flex>
  	</v-layout>
</template>

<script>
export default {
	name: 'section-create',
};
</script>

<style lang="scss" scoped>
.section-create {
	background-image: url('https://mibodega.s3-sa-east-1.amazonaws.com/BANNER+2.png');
    background-position: center;
    background-repeat: no-repeat;
	background-size: cover;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	padding: 80px 7%;

	@media (max-width: 934px) {
		background-image: none;
		padding: 0px;
	}
}

.banner-last-mobile {
	@media (max-width: 934px) {
		background-image: url('https://mibodega.s3-sa-east-1.amazonaws.com/BANNER+2+MOBIL+.png');
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		height: 408px;
	}
}

.title-create {
	color: color(green-dark);
	font-family: font(lato-regular);
	font-weight: map-get($weight, w900);
	font-size: size(large32);

	@media (max-width: 934px) {
		font-size: size(medium22);
	}
}

.description {
	color: color(green-dark);
	font-family: font(lato-regular);
	font-size: size(medium18);
}

.btn-information {
	background: color(white);
	border-radius: 9px;
	color: color(green-dark);
	display: inline-block;
	font-family: font(lato-regular);
	font-size: size(medium18);
	font-weight: map-get($weight, w900);
	margin: 23px 0px 0px;
	padding: 10px 46px;
	text-decoration: none;

	@media (max-width: 934px) {
		padding: 10px 43px;
		margin: 34px 0px 0px;
	}
}

.content-text {
	padding: 0px 0px 0px 100px;

	@media (max-width: 936px) {
		background-color: color(green-link);
		text-align: center;
		padding: 88px 5% 62px;
	}
}

.wrapper-image {
	width: 50%;

	@media (max-width: 936px) {
		display: none;
	}
}

.wrape-image-mobile {
	display: none;

	@media (max-width: 936px) {
		display: block;
	}
}

.img-cel {
	max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/home/section-create.vue